moduleDirectives = angular.module 'editor.directives', [
  "directives.htmlcompiler"
]



// WEBPACK FOOTER //
// ./src/app/editor/components/common/main.coffee